import React, { useEffect, useRef, useState } from 'react';
import { Alert, Modal } from 'antd';
import { orderStatusUpdateApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const BatchOrderUpdateFixed = ({
  visible,
  onClose,
  onSuccess,
  onReceipt,
  pointsBalance,
  selectedOrders = [],
}) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const submitting = useRef(false);
  const validOrders = selectedOrders.filter((order) => order.status === 0);
  const skippedCount = selectedOrders.length - validOrders.length;
  const hasBalance = pointsBalance != null;
  const enoughPoints = hasBalance && pointsBalance >= validOrders.length;
  useEffect(() => {
    if (visible) setError('');
  }, [visible]);
  const submit = async () => {
    if (submitting.current || !validOrders.length || !enoughPoints) return;
    submitting.current = true;
    setLoading(true);
    setError('');
    const receipt = {
      submittedAt: new Date().toISOString(),
      orders: validOrders.map(({ id, orderNo, storeName }) => ({ id, orderNo, storeName })),
      skippedCount,
      expectedPoints: validOrders.length,
    };
    try {
      const response = await orderStatusUpdateApi.batchUpdateToPlace(
        user?.username,
        validOrders.map((order) => order.id),
      );
      if (response.data?.code !== 200)
        throw new Error(response.data?.message || '更新失败');
      onReceipt?.({ ...receipt, outcome: 'received' });
      onSuccess();
    } catch (failure) {
      onReceipt?.({ ...receipt, outcome: 'unconfirmed', error: failure.message || '请求结果未确认' });
      setError(
        failure.message || '结果未确认，请先刷新订单与积分，核对后再操作。',
      );
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  return (
    <Modal
      title="转为待拍单"
      open={visible}
      onOk={submit}
      onCancel={() => {
        if (!loading) onClose();
      }}
      okText="确认转待拍单"
      cancelText="取消"
      confirmLoading={loading}
      okButtonProps={{ disabled: !validOrders.length || !enoughPoints }}
      cancelButtonProps={{ disabled: loading }}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
    >
      <p className="muted">
        仅处理待审核订单，每笔消耗 1 积分。
      </p>
      <dl className="batch-summary batch-decision">
        <dt>本次处理</dt>
        <dd>{validOrders.length} 笔订单</dd>
        <dt>预计消耗</dt>
        <dd>{validOrders.length} 积分</dd>
      </dl>
      <p className="muted batch-context">
        已选 {selectedOrders.length} 笔，跳过其他状态 {skippedCount} 笔。
        <br />
        可用积分：{hasBalance ? pointsBalance : '暂不可用'}
      </p>
      {!enoughPoints && (
        <Alert
          type="warning"
          showIcon
          message={
            hasBalance
              ? '积分不足，请联系业务对接人充值后再操作。'
              : '余额暂不可用，请关闭弹窗并刷新后重试。'
          }
        />
      )}
      {!validOrders.length && (
        <Alert type="info" showIcon message="所选订单中没有待审核订单。" />
      )}
      {error && (
        <Alert
          type="error"
          showIcon
          message={error}
          description="提交结果不明确时，请先关闭并刷新订单、核对积分，避免重复操作。"
        />
      )}
    </Modal>
  );
};
export default BatchOrderUpdateFixed;
